import { Observable } from 'rxjs';

export interface ChartAccountParams {
  major: string,
  sub_major: string,
  ledger: string,
  acct: string,
}

export interface AvailableChartAccountParams {
  year: string | number,
  campus: string | number
}

export interface ApiResponse {
  code: number,
  message: any
}

export abstract class ChartAccount {
  abstract getChartAccount(params: ChartAccountParams): Observable<ApiResponse>;
  abstract getAvailableChartAccount(params: AvailableChartAccountParams): Observable<ApiResponse>;
}
